import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const SMSEditorContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

export const SectionTitle = styled(Box)(() => ({
  fontFamily: "Manrope, sans-serif",
  fontSize: 14,
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: "#344054",
}));

export const FormRow = styled(Box)(() => ({
  display: "flex",
  gap: 12,
  width: "100%",
}));

export const EditorContainer = styled(Box)(() => ({
  border: "1px solid #E4E7EC",
  borderRadius: 8,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  minHeight: 326,
}));

export const CharacterCounter = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 4,
  padding: "4px 6px",
  borderTop: "1px solid #E4E7EC",
  backgroundColor: "#F9FAFB",
}));

export const CharacterCounterText = styled(Box)(() => ({
  fontFamily: "Manrope, sans-serif",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: "#475467",
}));

export const CharacterCounterHint = styled(Box)(() => ({
  fontFamily: "Manrope, sans-serif",
  fontSize: 12,
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
  color: "#667085",
}));

